import React, { useState } from 'react'
import { FormGroup, Label } from 'reactstrap'
import Resx from '@/components/Resx'
import { Validator } from '@/components/validation'
import { RichTextEditor } from '@/components/richTextEditor'
import { defaultChangeHandler, FileAttachments } from '@/components/fileAttachments'
import context from '@/context'

const RichTextWithAttachment = function RichTextWithAttachment (props) {
  const { message, attachments, replyMessage, replyAttachments, isReply, updateDto, readOnly } = props
  const [editor, setEditor] = useState(null)
  const onAttachmentChange = (e) => {
    const currentAttachments = isReply && isReply === true ? replyAttachments : attachments

    const a = defaultChangeHandler(e, currentAttachments)
    if (a !== currentAttachments) {
      props.updateAttachments(a, isReply)
    }
  }

  const updateRichTextValue = (value) => {
    if (!editor || editor.isValueEmpty(value)) {
      updateDto({ text: undefined }, isReply)
    } else {
      updateDto({ text: value }, isReply)
    }
  }

  const renderRichTextEditor = (currentText) => {
    return readOnly
      ? <RichTextEditor
        data-cy='TextEditor'
        ref={ref => { setEditor(ref) }}
        onChange={updateRichTextValue}
        value={currentText} r
        readOnly={readOnly} />
      : <Validator name='text' value={currentText} required>
        <RichTextEditor
          data-cy='TextEditor'
          ref={ref => { setEditor(ref) }}
          onChange={updateRichTextValue}
          value={currentText} />
      </Validator>
  }

  const currentText = isReply && isReply === true ? replyMessage.text : message.text
  const currentAttachments = isReply && isReply === true ? replyAttachments : attachments

  return (
    <React.Fragment>
      <FormGroup>
        <Label><Resx name={isReply === true ? 'Messages.Reply' : 'Messages.MessageText'} /></Label>
        {renderRichTextEditor(currentText)}
      </FormGroup>
      <FormGroup>
        <Label><Resx name='Common.Attachments' /></Label>
        <FileAttachments
          data-cy='FileAttachments' attachments={currentAttachments || []}
          readonly={readOnly}
          onChange={(e) => onAttachmentChange(e)}
          downloadAction={context.api.messagesService.download} />
      </FormGroup>
    </React.Fragment>
  )
}

export default RichTextWithAttachment



// WEBPACK FOOTER //
// ./src/components/messages/richtext-with-attachment.js